module.exports = __webpack_public_path__ + "static/media/flag-uz.a4ab42d5.webp";